
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cm-article-expired",
      function () {
        return require("private-next-pages/cm-article-expired.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cm-article-expired"])
      });
    }
  